/* eslint-disable react/prop-types */
import React, {useState} from 'react';
import {Box, Button, Typography, Card, CircularProgress} from '@mui/material';
import {ArrowBack, Map, Navigation} from '@mui/icons-material';

const API_BASE = 'https://kops.apiireit.com/gateway';

const StepNav = ({authUser, getToken, navPref, setNavPref, onBack, onNext}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const saveNavPreference = async value => {
    if (!authUser) {
      setError('Usuário não autenticado.');
      return;
    }
    if (!getToken) {
      setError('Não foi possível obter token de autenticação.');
      return;
    }

    setLoading(true);
    setError('');
    setNavPref(value);

    try {
      const token = await getToken();
      const params = new URLSearchParams({
        user: authUser.uid,
        nav: value,
      });

      const res = await fetch(
        `${API_BASE}/parceiros/nav?${params.toString()}`,
        {
          method: 'PUT',
          headers: {Authorization: `Bearer ${token}`},
        },
      );

      if (!res.ok) {
        const text = await res.text();
        throw new Error(
          text || `Erro ao salvar preferência de navegação (${res.status}).`,
        );
      }

      await res.json();
      onNext();
    } catch (err) {
      console.error('StepNav submit error:', err);
      setError(err.message || 'Erro ao salvar preferência de navegação.');
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = value => {
    if (loading) return;
    saveNavPreference(value);
  };

  return (
    <div>
      <Typography variant="h6" sx={{mb: 1, fontWeight: 800, color: '#1a1a2e'}}>
        Navegação preferida
      </Typography>

      <Typography
        variant="body2"
        sx={{mb: 2, color: '#8a94a6', lineHeight: 1.6}}
      >
        Escolha o app de navegação que você quer usar por padrão no app. Você
        poderá trocar essa preferência depois no menu.
      </Typography>

      <Box sx={{display: 'grid', gap: 3}}>
        <Button
          onClick={() => handleSelect('Google maps')}
          disabled={loading}
          startIcon={<Navigation sx={{color: '#fff'}} />}
          sx={{
            backgroundImage:
              'linear-gradient(90deg, #4285F4 0%, #34A853 50%, #EA4335 100%)',
            color: '#fff',
            border: '3px solid #fff',
            textTransform: 'none',
            minHeight: 56,
            borderRadius: 50,
            justifyContent: 'flex-start',
            px: 3,
            fontWeight: 700,
            boxShadow:
              navPref === 'Google maps'
                ? '0 10px 30px rgba(66, 133, 244, 0.2)'
                : 'none',
            ':hover': {
              opacity: 0.92,
            },
          }}
        >
          {loading && navPref === 'Google maps' ? (
            <CircularProgress size={18} sx={{color: '#fff'}} />
          ) : (
            'Google maps'
          )}
        </Button>

        <Button
          onClick={() => handleSelect('Waze')}
          disabled={loading}
          startIcon={<Map sx={{color: '#fff'}} />}
          sx={{
            bgcolor: '#05c8f7',
            color: '#fff',
            border: '3px solid #fff',
            textTransform: 'none',
            minHeight: 56,
            borderRadius: 50,
            justifyContent: 'flex-start',
            px: 3,
            fontWeight: 700,
            boxShadow:
              navPref === 'Waze'
                ? '0 10px 30px rgba(5, 200, 247, 0.22)'
                : 'none',
            ':hover': {
              opacity: 0.92,
            },
          }}
        >
          {loading && navPref === 'Waze' ? (
            <CircularProgress size={18} sx={{color: '#fff'}} />
          ) : (
            'Waze'
          )}
        </Button>

        <Card
          elevation={0}
          sx={{
            p: 2,
            backgroundColor: '#f8f9fb',
            borderRadius: 5,
            border: '1px solid #e5e7eb',
          }}
        >
          <Typography variant="subtitle2" sx={{fontWeight: 700, mb: 1}}>
            Observação
          </Typography>
          <Typography variant="body2" sx={{color: '#6b7280', lineHeight: 1.6}}>
            Se você não escolher agora, poderá alterar depois no app. Esse valor
            é apenas para sua preferência de rota.
          </Typography>
        </Card>

        {error && (
          <Typography
            variant="body2"
            sx={{color: '#d32f2f', mt: 1, fontWeight: 600}}
          >
            {error}
          </Typography>
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          gap: 12,
          mt: 3,
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {onBack && (
          <Button
            onClick={onBack}
            startIcon={<ArrowBack />}
            sx={{textTransform: 'none', color: '#6b7280'}}
          >
            Voltar
          </Button>
        )}
      </Box>
    </div>
  );
};

export default StepNav;
